<template>
    <el-dialog
            :title="!dataForm.id ? '新增' : '修改'"
            :close-on-click-modal="false"
            :visible.sync="visible"
            @close="closeDialog"
    >
        <el-form
                :model="dataForm"
                ref="dataForm"
                @keyup.enter.native="dataFormSubmit()"
                label-width="120px"
        >
            <el-form-item label="数据源" prop="datasourceId">
                <el-select v-model="dataForm.datasourceId" placeholder="数据源"
                           style="display: block;margin-bottom: 10px">
                    <el-option
                            v-for="item in datasourceList"
                            :key="item.id"
                            :label="item.text"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="表单编号" prop="code">
                <el-input v-model="dataForm.code" placeholder="表单编号"></el-input>
            </el-form-item>
            <el-form-item label="表单标题" prop="title">
                <el-input v-model="dataForm.title" placeholder="表单标题"></el-input>
            </el-form-item>
            <el-form-item label="表单类型" prop="formType">
                <el-select v-model="dataForm.formType" placeholder="表单类型"
                           style="display: block;margin-bottom: 10px">
                    <el-option
                            v-for="item in formTypeList"
                            :key="item.id"
                            :label="item.text"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
          <el-form-item label="业务类型" prop="formType">
            <el-select v-model="dataForm.busType" placeholder="业务类型"
                       style="display: block;margin-bottom: 10px">
                <el-option v-for="(item,index) in businessTypeNamelist"
                           :key="index"
                           :label="item.name"
                           :value="item.value"
                ></el-option>
            </el-select>
          </el-form-item>
            <el-form-item label="是否支持附件" v-if="dataForm.formType==1" prop="hasAttach">
                <el-select v-model="dataForm.hasAttach" placeholder="是否支持附件"
                           style="display: block;margin-bottom: 10px">
                    <el-option
                            v-for="item in trueOrFalseOptions"
                            :key="item.value"
                            :label="item.text"
                            :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="是否支持流程" v-if="dataForm.formType==1" prop="hasFlow">
                <el-select v-model="dataForm.hasFlow" placeholder="是否支持流程"
                           style="display: block;margin-bottom: 10px">
                    <el-option
                            v-for="item in trueOrFalseOptions"
                            :key="item.value"
                            :label="item.text"
                            :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="变更记录标识" v-if="$customFormGlobalConfig.showHistoryConfig && dataForm.formType==1" prop="showHistoryTag">
                <el-select v-model="dataForm.showHistoryTag" placeholder="是否标识变更记录"
                           style="display: block;margin-bottom: 10px">
                    <el-option
                        v-for="item in showHistoryTagEnumList"
                        :key="item.id"
                        :label="item.text"
                        :value="parseInt(item.id)">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="流程模板键值" v-if="dataForm.formType==1" prop="flowTemplateKey">
                <el-input
                        v-model="dataForm.flowTemplateKey"
                        placeholder="流程模板键值"
                ></el-input>
            </el-form-item>
            <el-form-item label="排序" prop="dataSort">
                <el-input
                        v-model="dataForm.dataSort"
                        placeholder="排序"
                ></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
    </el-dialog>
</template>

<script>
import {
    apiCustomformDatasourceconfigNodeList,
    apiCustomformGet, apiCustomformGetEnumList,
    apiCustomformSave, apiSysDictDataGetList
} from "../../server/formConfig";

    const fromData = {
        id: "",
        name: "",
        description: "",
        datasourceId: "",
        formType: 1,
        hasAttach: false,
        hasFlow: false,
        flowTemplateKey: '',
        dataStatus: 0,
        dataSort: 10,
        showHistoryTag: 0,
    }
    export default {
        data() {
            return {
                visible: false,
                datasourceList: [],
                trueOrFalseOptions: [{'text': '否', 'value': false}, {'text': '是', 'value': true}],
                formTypeList: [{id: 0, text: '列表'}, {id: 1, text: '明细'}],
                businessTypeNamelist: [],
                busTypeList: [{type: 'GC', text: '工程建设'}, {type: 'CG', text: '政府采购'}, {type: 'GT', text: '国有产权'}, {type: 'CQ', text: '农村产权'}],
                dataForm: fromData,
                showHistoryTagEnumList: [], //变更记录标识枚举
            };
        },
        mounted() {
            this.getDic('jz_dgwitness_bustype');
            this.getShowHistoryTagEnumList()
        },
        methods: {
            //获取变更记录标识枚举
            getShowHistoryTagEnumList() {
                if(!this.$customFormGlobalConfig.showHistoryConfig) return

                apiCustomformGetEnumList(12).then((res) => {
                    this.showHistoryTagEnumList = res.data
                })
            },
            getDic(type) { // 获取字典
                apiSysDictDataGetList(type).then(res => {
                    if (res.data.code === '1') {
                        switch (type) {
                            case 'jz_dgwitness_bustype':
                                this.businessTypeNamelist = res.data.data;
                                break;
                        }
                    }
                })
            },
            initSelectData() {
                apiCustomformDatasourceconfigNodeList().then(({data}) => {
                    this.datasourceList = data;
                });
            },
            init(id) {
                this.dataForm.id = id || "";
                this.visible = true;
                this.initSelectData()
                if (this.dataForm.id) {
                    apiCustomformGet(this.dataForm.id).then(({data}) => {
                        console.log(data)
                        if (data && data.code === "1") {
                            this.dataForm = data.data;
                            console.log(this.dataForm)
                        } else {
                            this.dataForm = fromData;
                        }
                    });
                }
            },
            closeDialog() {
                this.visible = false;
                this.dataForm = fromData;
            },
            // 表单提交
            dataFormSubmit() {
                apiCustomformSave(this.dataForm).then(({data}) => {
                    if (data && data.code === "1") {
                        this.$message({
                            message: "操作成功",
                            type: "success",
                            duration: 1500,
                            onClose: () => {
                                this.visible = false;
                                this.$emit("refreshDataList");
                            },
                        });
                    } else {
                        this.$message.error(data.msg);
                    }
                });
            },
        },
    };
</script>
